import { mapAssetsBaseUrl } from '../../mappers/asset/asset-base-url.mapper';
import { AssetsFile } from '../../types/asset/asset.types.ts';

import { s3RequestClientUtil } from '../clients/s3.client.util.ts';

const PRODUCTION_ENV_DIRECTORY = 'production';
const PRODUCTION_BUCKET_NAME = 'assets.readingcritters.com';
const INTEGRATION_BUCKET_NAME = 'assets.int.readingcritters.com';

export class AssetFilesUtil {
  private static _instance: AssetFilesUtil;
  // I don't really like the fact we now have two sources of truth for the environment
  // We could theoretically store asset data in redux and implement only the heavy logic parts in utils
  // We'd need a slice with all data, and then we could use selectors to get the parts we need
  private env: string | undefined = undefined;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  public static get instance(): AssetFilesUtil {
    if (!AssetFilesUtil._instance) {
      AssetFilesUtil._instance = new AssetFilesUtil();
    }
    return AssetFilesUtil._instance;
  }

  public setEnvironment(env?: string): void {
    this.env = env;
  }

  public async loadAssetsFile(): Promise<AssetsFile> {
    const url = this.getS3Url('data', 'json');
    const response = await s3RequestClientUtil.get<AssetsFile>(url);
    return response.data;
  }

  public getS3Url(filename: string, fileType: string): string {
    const shouldUseProduction = !this.env || this.env === PRODUCTION_ENV_DIRECTORY;
    const bucketName = shouldUseProduction ? PRODUCTION_BUCKET_NAME : INTEGRATION_BUCKET_NAME;
    const envName = shouldUseProduction ? PRODUCTION_ENV_DIRECTORY : this.env;
    const baseUrl = mapAssetsBaseUrl(bucketName);

    return `${baseUrl}/${envName}/${filename}.${fileType}`;
  }
}

// Export a singleton instance
export const getAssetFilesUtil = (): AssetFilesUtil => AssetFilesUtil.instance;
